import React, { useState } from 'react';
import Switch from '@mui/material/Switch';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import {
  disablePushNotifications,
  isPushNotificationsEnabled,
  setupPushNotifications,
} from '../../utils/pushNotifications';

function Notifications() {
  const [enabled, setEnabled] = useState(isPushNotificationsEnabled());
  const [loading, setLoading] = useState(false);

  const handleToggle = async (event) => {
    const checked = event.target.checked;
    setLoading(true);

    if (!checked) {
      await disablePushNotifications();
      setEnabled(false);
      setLoading(false);
      toast('Notifications turned off', { autoClose: 3000 });
      return;
    }

    const userData = localStorage.getItem('userdetails');
    if (!userData) {
      swal('Please log in again to enable notifications.');
      setEnabled(false);
      setLoading(false);
      return;
    }

    let user;
    try {
      user = JSON.parse(userData);
    } catch (error) {
      swal('Your session data could not be read. Please log in again to enable notifications.');
      setEnabled(false);
      setLoading(false);
      return;
    }

    const result = await setupPushNotifications(user, { forceRegister: true });
    const isEnabled = result?.enabled === true;

    setEnabled(isEnabled);
    setLoading(false);

    if (isEnabled) {
      toast('Notifications turned on', { autoClose: 3000 });
      return;
    }

    if (!isEnabled) {
      const permissionBlocked =
        typeof Notification !== 'undefined' && Notification.permission === 'denied';

      swal(
        permissionBlocked
          ? 'Notifications are blocked in your browser settings. Please allow them in Chrome to turn this on.'
          : result?.message || 'Notifications could not be enabled. Please try again.'
      );
    }
  };

  return (
    <div className='max-w-2xl'>
      <div className='flex items-center justify-between gap-6 rounded-lg border border-gray-200 bg-white p-5'>
        <div>
          <h1 className='mb-2 text-[20px] font-bold text-[#1E222B]'>Push notifications</h1>
          <p className='text-[15px] text-[#44474E]'>
            Receive browser notifications for important HalalWealth updates.
          </p>
        </div>

        <Switch
          checked={enabled}
          disabled={loading}
          onChange={handleToggle}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': {
              color: '#7442C8',
            },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: '#7442C8',
            },
          }}
          inputProps={{ 'aria-label': 'Toggle push notifications' }}
        />
      </div>
    </div>
  );
}

export default Notifications;
